// externals
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// libraries
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import type { StateTree } from '@makemydeal/dr-dash-types';
import { sharedBootstrapSelectors } from '@makemydeal/dr-shared-store';
import * as tradeInSelectors from '@makemydeal/dr-dash-store/selectors/trade';
import * as dealXgDetailsSelectors from '@makemydeal/dr-dash-store/selectors/dealXgDetailsSelectors';
import * as baseDealActionCreators from '@makemydeal/dr-dash-store/actions/baseDealActionCreators';
import * as interactionAnalyticsActionCreators from '@makemydeal/dr-dash-store/actions/interactionAnalyticsActionCreators';
import { ACTIVITY_NAME_TRADE_IN } from '@makemydeal/dr-dpm-client';

// components
import DealActivityCard from '../DealActivityCard.interstate';

const name = 'tradeIn';

const TradeCard = () => {
    const dispatch = useDispatch();
    const tradeNetValue = useSelector(tradeInSelectors.getTradeNetValue);
    const isBootstrapped = useSelector(sharedBootstrapSelectors.wasBootstrapSuccessful);
    const completed = useSelector(tradeInSelectors.isTradeInCompleted);
    const cardValue = tradeNetValue ? formatDollarsAndCents(tradeNetValue) : '$0.00';
    const tradeDpmState = useSelector((state: StateTree) =>
        dealXgDetailsSelectors.getDpmStateByActivity(state, ACTIVITY_NAME_TRADE_IN)
    );

    const handleCardClick = () => {
        // Trade's selectors are only created on BOOTSTRAP_SUCCESS; don't open the slide-out before then.
        if (!isBootstrapped) return;

        // Dispatch analytics action
        dispatch(interactionAnalyticsActionCreators.valueTradeInStartLink());

        dispatch(baseDealActionCreators.openSlideOut(baseDealActionCreators.SlideOutType.TradeIn));
    };

    return (
        <DealActivityCard
            dpmState={tradeDpmState}
            name={name}
            showCardAnchor={true}
            cardValue={cardValue}
            completed={completed}
            action={handleCardClick}
        />
    );
};

export default TradeCard;
